<template>
  <div class="unlock-config">
    <div class="group-card">
      <h3 class="group-title">对照组</h3>
      <FormItem
        label="会员UI样式"
        :label-width="120"
        prop="controlGroupParam.uiStyle"
        :rules="[
          {
            required: true,
            message: '请选择会员UI样式',
            trigger: 'change'
          }
        ]"
      >
        <Select
          :value="controlGroup.uiStyle"
          :disabled="disabled"
          placeholder="请选择UI样式"
          @on-change="handleControlChange('uiStyle', $event)"
        >
          <Option
            v-for="item in uiStyleOptions"
            :key="'control-ui-' + item.value"
            :value="item.value"
            :label="item.label"
          >
            <span class="style-option-label">
              <Poptip trigger="hover" transfer placement="left">
                <Icon class="style-tip-icon" type="md-help-circle" />
                <template #content>
                  <img class="style-img" :src="item.tipImage" />
                </template>
              </Poptip>
              {{ item.label }}
            </span>
          </Option>
        </Select>
      </FormItem>

      <FormItem
        label="会员价格文案"
        :label-width="120"
        prop="controlGroupParam.priceText"
        :rules="[
          {
            required: true,
            message: '请选择会员价格文案',
            trigger: 'change'
          }
        ]"
      >
        <Select
          :value="controlGroup.priceText"
          :disabled="disabled"
          placeholder="请选择价格文案"
          @on-change="handleControlChange('priceText', $event)"
        >
          <Option
            v-for="item in priceTextOptions"
            :key="'control-price-' + item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </FormItem>
    </div>

    <div
      v-for="(group, index) in formData.groups"
      :key="index"
      class="group-card"
    >
      <h3 class="group-title">实验组{{ index + 1 }}</h3>

      <FormItem
        label="会员UI样式"
        :label-width="120"
        :prop="`groups[${index}].experimentGroupParam.uiStyle`"
        :rules="[
          {
            required: true,
            message: '请选择会员UI样式',
            trigger: 'change'
          }
        ]"
      >
        <Select
          :value="getGroupParam(index).uiStyle"
          :disabled="disabled"
          placeholder="请选择UI样式"
          @on-change="handleChange(index, 'uiStyle', $event)"
        >
          <Option
            v-for="item in uiStyleOptions"
            :key="'group-ui-' + index + '-' + item.value"
            :value="item.value"
            :label="item.label"
          >
            <span class="style-option-label">
              <Poptip trigger="hover" transfer placement="left">
                <Icon class="style-tip-icon" type="md-help-circle" />
                <template #content>
                  <img class="style-img" :src="item.tipImage" />
                </template>
              </Poptip>
              {{ item.label }}
            </span>
          </Option>
        </Select>
      </FormItem>

      <FormItem
        label="会员价格文案"
        :label-width="120"
        :prop="`groups[${index}].experimentGroupParam.priceText`"
        :rules="[
          {
            required: true,
            message: '请选择会员价格文案',
            trigger: 'change'
          }
        ]"
      >
        <Select
          :value="getGroupParam(index).priceText"
          :disabled="disabled"
          placeholder="请选择价格文案"
          @on-change="handleChange(index, 'priceText', $event)"
        >
          <Option
            v-for="item in priceTextOptions"
            :key="'group-price-' + index + '-' + item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </FormItem>
    </div>
  </div>
</template>

<script>
import style1 from '@/assets/images/unlock-style1.png'
import style2 from '@/assets/images/unlock-style2.png'

export default {
  name: 'UnlockLayerConfig',
  props: {
    formData: {
      type: Object,
      required: true
    },
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uiStyleOptions: [
        { value: 'STYLE_ONE', label: '样式一', tipImage: style1 },
        { value: 'STYLE_TWO', label: '样式二', tipImage: style2 }
      ],
      priceTextOptions: [
        { value: 'PRICE_TEXT_TWO', label: '低至XXX/天' },
        { value: 'PRICE_TEXT_ONE', label: 'XXX/周' }
      ]
    }
  },
  computed: {
    controlGroup() {
      return this.formData.controlGroupParam || {}
    }
  },
  methods: {
    getGroupParam(index) {
      const group =
        this.formData.groups &&
        this.formData.groups[index] &&
        this.formData.groups[index].experimentGroupParam
      return group || {}
    },
    handleControlChange(key, value) {
      if (!this.formData.controlGroupParam) {
        this.$set(this.formData, 'controlGroupParam', {})
      }
      this.$set(this.formData.controlGroupParam, key, value)
    },
    handleChange(index, key, value) {
      const group =
        this.formData.groups &&
        this.formData.groups[index] &&
        this.formData.groups[index].experimentGroupParam

      if (!group) return
      this.$set(group, key, value)
    },
    validate() {
      const controlGroup = this.formData.controlGroupParam || {}
      if (!(controlGroup.uiStyle && controlGroup.priceText)) {
        this.$Message.error('请完善对照组广告解锁层 UI 配置')
        return false
      }

      return (this.formData.groups || []).every((group) => {
        const config = group.experimentGroupParam || {}
        return Boolean(config.uiStyle && config.priceText)
      })
    }
  }
}
</script>

<style scoped lang="less">
.unlock-config {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin: 20px 0;
}

.group-card {
  flex: 0 1 45%;
  box-sizing: border-box;
  border: 1px solid #e8eaec;
  padding: 20px;
  border-radius: 4px;
}

.group-title {
  margin-bottom: 20px;
}

.style-option-label {
  display: inline-flex;
  align-items: center;
}

.style-tip-icon {
  cursor: pointer;
  margin-right: 8px;
}

.style-img {
  display: block;
  width: 320px;
  max-width: 100%;
}
</style>
